/**
 * @author Jersson Stiven Morales Alza
 * @Copyright (c) Infotrack. All rights reserved.
 */
import React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { Card, CardContent, Grid, MenuItem, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';

import Tabla from '@infotrack/presentacion-componentes/tabla';
import Texto from '@infotrack/presentacion-componentes/texto';

import { BotonBuscar, BotonLimpiar } from 'Infotrack@Transversales/componentes/botonesAcciones';
import { ITablaClientesVistaProps } from '../interfaces';
import { acciones, columnas, opciones } from './constantes';

const VistaClientes: React.FunctionComponent<ITablaClientesVistaProps & InjectedIntlProps> = ({
    alCambiarMunicipio,
    alCambiarValor,
    cargarClientes,
    consultaClientes,
    confirmarEliminacion,
    entidadesCliente,
    intl,
    manejarFormulario,
    refTabla,
    filtros,
}) => (
    <Grid container spacing={2}>
        <Grid item xs={12}>
            <Card>
                <CardContent>
                    <Grid alignItems="center" container justifyContent="space-between" spacing={2}>
                        <Grid item md={true} xs={12}>
                            <Autocomplete
                                getOptionLabel={({ NombreMunicipio }: any) => NombreMunicipio}
                                onChange={(_: any, municipio: any) => alCambiarMunicipio(municipio)}
                                options={entidadesCliente.municipios}
                                renderInput={(params: any) => (
                                    <TextField {...params} fullWidth label={<Texto id="clientes.ciudadId" />} />
                                )}
                                value={filtros.Ciudad}
                                id={`ciudadId-${filtros.Ciudad}`}
                            />
                        </Grid>
                        <Grid item md={true} xs={12}>
                            <TextField
                                fullWidth
                                label={<Texto id="clientes.tipoClienteId" display="inline" />}
                                name="TipoClienteId"
                                onChange={alCambiarValor}
                                select
                                value={filtros.TipoClienteId}
                                id={`TipoClienteId-${filtros.TipoClienteId}`}
                            >
                                {entidadesCliente.tiposClientes.map(({ TipoClienteDescripcion, TipoClienteId }) => (
                                    <MenuItem key={TipoClienteId} value={TipoClienteId}>
                                        {TipoClienteDescripcion}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                        <Grid item md={true} xs={12}>
                            <TextField
                                fullWidth
                                label={<Texto id="clientes.nombreContacto" />}
                                onChange={alCambiarValor}
                                name="NombreContacto"
                                value={filtros.NombreContacto}
                                id={`NombreContacto-${filtros.NombreContacto}`}
                            />
                        </Grid>
                        <Grid item md={true} xs={12}>
                            <TextField
                                fullWidth
                                label={<Texto id="clientes.descripcionCliente" />}
                                onChange={alCambiarValor}
                                name="DescripcionCliente"
                                value={filtros.DescripcionCliente}
                                id={`DescripcionCliente-${filtros.DescripcionCliente}`}
                            />
                        </Grid>
                        <Grid item md="auto" xs={12}>
                            <Grid container spacing={2} justifyContent="center">
                                <Grid item md xs={6}>
                                    <BotonLimpiar onClick={() => cargarClientes(true)} id={'Boton-Limpiar'}/>
                                </Grid>
                                <Grid item md xs={6}>
                                    <BotonBuscar onClick={() => cargarClientes()} id={'Boton-Buscar'}/>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </Grid>
        <Grid item xs={12}>
            <Tabla
                actions={acciones(manejarFormulario, cargarClientes, intl.formatMessage, confirmarEliminacion)}
                columns={columnas(intl.formatMessage)}
                data={consultaClientes}
                tableRef={refTabla}
                options={opciones}
            />
        </Grid>
    </Grid>
);

export default injectIntl(VistaClientes);
